import React, { useState, createContext, useContext, useEffect } from "react";
import { Radio, Select, Form, Skeleton, Input } from "antd";
import MonthlysettingStore from "../store/monthlysettingstore";
import { observer } from "mobx-react-lite";
import wrfmSettingStore from "../store/wrfmsettingstore";
const monthlySettingStoreCtx = createContext(MonthlysettingStore);
const _ = require("underscore");
const { Option } = Select;

export const Well = observer(() => {
  useEffect(() => {
    async function loadWells() {
      await wrfmSettingStore.loadWells();
    }
    loadWells();
  }, []);

  const [well, setWell] = useState("0");
  const monthlySettingStore = useContext(monthlySettingStoreCtx);
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{ justifyContent: "center", display: "flex" }}
        >
          <Radio.Group
            buttonStyle="solid"
            onChange={({ target }) => {
              setWell(target.value);
            }}
            defaultValue={well}
            value={well}
          >
            <Radio.Button value="0">Select Existing Well</Radio.Button>
          </Radio.Group>
        </div>
      </div>

      <div className="ms-Grid-row">
        {well === "0" && (
          <div
            className="ms-Grid-col ms-sm12"
            style={{
              padding: "20px",
              justifyContent: "center",
              display: "flex",
            }}
          >
            {monthlySettingStore.isloading ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <Form.Item
                label={`Select ${monthlySettingStore.selField} Well`}
                required
              >
                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder={`Select ${monthlySettingStore.selField} Well`}
                  optionFilterProp="children"
                  value={monthlySettingStore.selWell}
                  onChange={(value, selItem) => {
                    monthlySettingStore.selWellId = value.toString();
                    monthlySettingStore.selWell = selItem.children;
                    console.log(value);
                  }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {[...wrfmSettingStore.wells.values()].map((w) => (
                    <Option key={w.wellId} value={w.wellId}>
                      {w.wellName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

